<h1>This is Core Component</h1>
<router-outlet></router-outlet>
